export class Menu {
    constructor (domElm) {
        this.domElm = domElm;

        // Get menu elements
        this.navContainer = this.domElm.querySelector('.navigation');
        this.burgerMenu = this.domElm.querySelectorAll('.burger-menu-button');
        this.menuElments = this.domElm.querySelectorAll('.menu-item-has-children > .link');

        // Initialiser --scroll-progress immédiatement
        this.initScrollProgress();

        this.addListeners();
        this.init();
    }

    initScrollProgress() {
        if (this.isScrolledByDefault) {
            // Force la progression à 1 pour les pages avec logo fixe dans le header
            document.body.style.setProperty('--scroll-progress', '1');
            document.body.style.setProperty('--_scroll-progress', '1');
        } else if (this.needScrollListener) {
            // Initialiser à la position actuelle du scroll
            const progress = Math.max(0, Math.min(1, window.scrollY / this.scrollMax));
            document.body.style.setProperty('--scroll-progress', progress);
        }
    }

    get scrollMax () {
        return window.innerHeight;
    }

    get scrollThreshold () {
        // Pour les pages single, spécifique on veut que la classe scrolled s'applique dès le début
        return (document.body.classList.contains('single') || document.body.classList.contains('direct-scroll')) ? 1 : this.scrollMax;
    }

    get isScrolledByDefault () {
        // Vérifier si la classe scrolled est déjà présente au chargement (ex: page contact)
        return document.body.classList.contains('scrolled');
    }

    addListeners () {
        this.burgerMenu.forEach(burgerMenu => burgerMenu.addEventListener('click', () => {
            this.domElm.classList.toggle('open');
            document.body.classList.toggle('no-scroll');
        }));

        this.menuElments.forEach((elm) => {
            elm.parentElement.querySelector('.back-button')?.addEventListener('click', (ev) => {
                ev.preventDefault();

                elm.parentElement.classList.remove('open');
            });

            elm.addEventListener('click', (ev) => {
                ev.preventDefault();

                elm.parentElement.classList.toggle('open');
            });
        });

        // === Listener for scroll
        if (this.needScrollListener && !this.isScrolledByDefault) {
            window.addEventListener('scroll', () => {
                document.body.style.setProperty('--scroll-progress', Math.max(0, Math.min(1, window.scrollY / this.scrollMax)));
                if (window.scrollY >= this.scrollThreshold) {
                    document.body.classList.add('scrolled');
                } else {
                    document.body.classList.remove('scrolled');
                }
            });
        }

        window.addEventListener('resize', () => {
            setTimeout(() => {
                document.body.style.setProperty('--menu-height', this.navContainer.clientHeight + 'px');
            }, 500);
        });
    }

    init () {
        // === Menu height
        document.body.style.setProperty('--menu-height', this.navContainer.clientHeight + 'px');

        // === Scroll progress
        if (this.needScrollListener) {
            document.body.style.setProperty('--scroll-progress', Math.max(0, Math.min(1, window.scrollY / this.scrollMax)));
        }
    }

    get needScrollListener() {
        return document.body.classList.contains('menu-scroll') || document.body.classList.contains('menu-over')
    }
}
